"use client";

import { ArrowRight, BookOpen, Lightbulb, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const services = [{
    id: 1,
    icon: Lightbulb,
    title: "Business Operational Guidance",
    description: "Navigate complex operational challenges with expert consulting tailored to your business needs.",
    link: "/ServicesPage"
  }, {
    id: 2,
    icon: TrendingUp,
    title: "Financial Management Improvement",
    description: "Strengthen financial systems and develop strategic plans for sustainable growth and profitability.",
    link: "/ServicesPage"
  }, {
    id: 3,
    icon: BookOpen,
    title: "Customized Workshops & Advisory",
    description: "Participate in hands-on workshops and one-on-one sessions designed to address your unique goals.",
    link: "/ServicesPage"
  }];
  return <section className="py-24 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-foreground mb-4">Our Services</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We provide non-accredited educational services and professional consulting to help clients navigate business operations, improve financial management, and develop strategic plans.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const ref = i === 0 ? card1Ref : i === 1 ? card2Ref : card3Ref;
          const isVisible = i === 0 ? card1Visible : i === 1 ? card2Visible : card3Visible;
          const Icon = service.icon;
          const delay = i * 100;
          return <div key={service.id} data-index={i} ref={ref} className={`transition-all duration-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: isVisible ? `${delay}ms` : "0ms"
          }}>
                <Card className="card h-full flex flex-col hover:shadow-medium transition-all duration-300">
                  <CardHeader className="flex-col items-start gap-4">
                    <div className="p-3 rounded-lg bg-primary/10 text-primary">
                      <Icon className="size-8" />
                    </div>
                    <CardTitle className={i === 0 || i === 1 || i === 2 ? "text-black" : "text-foreground"}>{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Button asChild variant="outline" size="sm" className="group">
                      <Link to={service.link}>
                        Learn More
                        <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}